import React, { useContext, useEffect, useRef, useState } from "react";
import * as S from "./ChatbotGeneralCase.style"
import { ThemeContext } from 'styled-components';
import { useLazyQuery } from "@apollo/client";
import { CONSULT_GENERAL_CHAT_IN_FLORENCE_CHATGPT } from "../../../../../../graphql/mutations/Chat";
import useSize from "../../../../../../hooks/useSize";
import { useTranslation } from "react-i18next";
import useDoctorData from "../../../../../../hooks/useDoctorData";
import ZaialoadingPoints from "../../../../../zaiaComponents/zaiaLoadingPoints";
import ChatbotInput from "../../chatbotInput";
import Message from "../../message";
import { useStateValue } from "../../../../../../contextAPI/StateProvider";
import { useAIGeneralKnowledgeStream } from "../../../../../../hooks/useAIGeneralKnowledgeStream";

const bgChatbot = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaFigures/chat-background.svg`
const monacoChatbot = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaFigures/monaco-logo.svg`

function ChatbotGeneralCase() {
  const element = document.getElementById("chatbot-container");
  const [t] = useTranslation("global");
  const { doctorData } = useDoctorData();
  const [{ generativeChatbotAlgorithmPrompt }, dispatch] = useStateValue();
  const { startStreaming, clearStreaming, loadingStreaming, answerStreaming, reasoningStreaming, isThinking } = useAIGeneralKnowledgeStream();
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    if (generativeChatbotAlgorithmPrompt) {
      startStreaming(`
        ${t("globally.generalKnowledgePrompt")} "${generativeChatbotAlgorithmPrompt}"

        ${t("globally.sourcesCaption")}
      `);
      dispatch({
        type: "SET_GENERATIVE_CHATBOT_ALGORITHM_PROMPT",
        generativeChatbotAlgorithmPrompt: undefined,
      });
    }
  }, [generativeChatbotAlgorithmPrompt, dispatch]);  
  

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    saveMessage(values.msg, 'doctor');
    sendBotMessage(values.msg, setSubmitting, resetForm);
    autoScroll(true);
  };

  const sendBotMessage = async (msg, setSubmitting, resetForm) => {    
    try {
      if(resetForm) resetForm();
      if(setSubmitting) setSubmitting(false);
      // sendChatbotMessage(msg);
      startStreaming(`
        ${t("globally.generalKnowledgePrompt")} "${msg}"  

        ${t("globally.sourcesCaption")}
      `);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    if(
      !loadingStreaming && 
      answerStreaming && 
      !isThinking
    ) {
      saveMessage(answerStreaming, 'bot');
      clearStreaming();
    }
  }, [loadingStreaming, answerStreaming, reasoningStreaming, isThinking]);


  const saveMessage = (msg, type) => {
    const senderName = type === 'doctor' ? `${doctorData.name} ${doctorData.lastname}` : t("globally.chatbotName"); 
    let allMessages = messages;
    allMessages.push(
      {
        id: Date.now(),
        message: msg,
        senderName: senderName,
        type: type
      }
    )
    setMessages([...allMessages])
  }

  const autoScroll = (force = false) => {
    const element = document.getElementById("chatbot-container");
    if (element) {
      const isAtBottom = element.scrollHeight - element.scrollTop - element.clientHeight < 100;
      if (force || isAtBottom) {
        element.scrollTop = element.scrollHeight - element.clientHeight;
      }
    }
  }

  useEffect(() => {
    autoScroll();
  }, [answerStreaming, loadingStreaming, messages]);

  const [chatBotGeneral, {loading: chatBotGeneralLoading}] = useLazyQuery(
    CONSULT_GENERAL_CHAT_IN_FLORENCE_CHATGPT,
    {
      fetchPolicy: "network-only"
    }
  );

  const sendChatbotMessage = async (msg) => {
    const {
      data: {
        consult_chat_gpt,
      },
    } = await chatBotGeneral({
      variables: {
        prompt: `
          ${t("globally.generalKnowledgePrompt")} "${msg}"

          ${t("globally.sourcesCaption")}
        `,
      },
    });

    if (!chatBotGeneralLoading ) {
      setMessages(
        [
          ...messages,
          {
            id: Date.now(),
            message: consult_chat_gpt.answer,
            senderName: t("globally.chatbotName"),
            type: 'bot',
          }
        ]
      )
      autoScroll(true)
    }
  }
  
  return (
    <S.ChatbotGeneralCase>
      <div className="chatbot-container" id="chatbot-container">
        {
          messages.length === 0 && !generativeChatbotAlgorithmPrompt && !chatBotGeneralLoading &&
          <div className="chatbot-container__empty">
            <div className="chatbot-container__empty-container">
              <img src={monacoChatbot} alt="" className="chatbot-container__empty-image" />
              <div className="chatbot-container__empty-container__shadow"></div>
            </div>
            <div className="chatbot-container__empty-msg">
              {t("chatbotAI.general.letsTalk")}
            </div>
          </div>
        }
        {messages.map((message, index) => (
          <div key={message.id}>
            { 
              <Message
                key={index}
                message={message.message?.replace('0chatgpt', '')}
                senderName={message.senderName}
                option={message.type}
              />
            }
          </div>
        ))}
        {
          answerStreaming &&
          <Message
            senderName={t("globally.chatbotName")}
            message={answerStreaming}
            option={'bot'}
          />
        }
        { 
          isThinking
          ? <Message
            senderName={t("globally.chatbotName")}
          >
            <ZaialoadingPoints />
          </Message> 
          : null
        }
      </div>
      <div className="chatbot-footer">
        <ChatbotInput
          chatbotDisabled={loadingStreaming}
          handleSubmit={handleSubmit}
        />
      </div>
    </S.ChatbotGeneralCase>
  );

}

export default ChatbotGeneralCase;
